import { Component, ElementRef, EventEmitter, Input, Output } from '@angular/core';
import { Observable } from 'rxjs/Rx';

@Component({
  selector: 'input-debounce',
  template: '<input type="text" [placeholder]="placeholder" [(ngModel)]="inputValue"  [style]="style" [class]="class">',
})
export class InputDebounceComponent {
  @Input() placeholder: string;
  @Input() style: string;
  @Input() class: string;
  @Input() delay = 1000;
  @Output() value = new EventEmitter();

  public inputValue: string;

  constructor(private elementRef: ElementRef) {
    const eventStream = Observable.fromEvent(elementRef.nativeElement, 'keyup')
      .map(() => this.inputValue)
      .debounceTime(this.delay)
      .distinctUntilChanged();

    eventStream.subscribe(input => this.value.emit(input));
  }
}



// WEBPACK FOOTER //
// ./src/app/common/helper/input-debounce.component.ts